import { Component, Input, OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Observable } from 'rxjs'
import { distinctUntilChanged, filter, map } from 'rxjs/operators'
import { InteriorViewModelYComponent } from '../interior-view-model-y/interior-view-model-y.component'

@Component({
    selector: 'mg-preview-model-y',
    templateUrl: './preview-model-y.component.html',
    styleUrls: ['./preview-model-y.component.scss'],
})
export class PreviewModelYComponent implements OnInit {
    constructor(public dialog: MatDialog) {}

    @Input() influencingValues$: Observable<{ [optionName: string]: { id: string; label: string } }>

    activePath$: Observable<string>

    ngOnInit() {
        this.activePath$ = this.influencingValues$.pipe(
            map(({ paint, rims }) => this.getImageUrl(paint.label, rims.label)),
            filter(activePath => this.carsUrls.map(({ path }) => path).includes(activePath)),
            distinctUntilChanged()
        )
    }

    carsUrls = [
        { path: 'redmulticoat-gemini' },
        { path: 'redmulticoat-induction' },
        { path: 'redmulticoat-uberturbine' },

        { path: 'white-gemini' },
        { path: 'white-induction' },
        { path: 'white-uberturbine' },

        { path: 'deepbluemetallic-gemini' },
        { path: 'deepbluemetallic-induction' },
        { path: 'deepbluemetallic-uberturbine' },

        { path: 'solidblack-gemini' },
        { path: 'solidblack-induction' },
        { path: 'solidblack-uberturbine' },

        { path: 'midnightsilver-gemini' },
        { path: 'midnightsilver-induction' },
        { path: 'midnightsilver-uberturbine' },

        { path: 'cherryred-gemini' },
        { path: 'cherryred-induction' },
        { path: 'cherryred-uberturbine' },

        { path: 'quicksilver-gemini' },
        { path: 'quicksilver-induction' },
        { path: 'quicksilver-uberturbine' },
    ]

    translatePaint(paint): string {
        switch (paint) {
            case 'Pearl White Multi-Coat':
                return 'white'
            case 'Deep Blue Metallic':
                return 'deepbluemetallic'
            case 'Midnight Silver Metallic':
                return 'midnightsilver'
            case 'Multi-Coat Red':
                return 'redmulticoat'
            case 'Solid Black':
                return 'solidblack'
            case 'Midnight Cherry Red':
                return 'cherryred'
            case 'Quicksilver':
                return 'quicksilver'
            default:
                return ''
        }
    }

    translateRims(rims): string {
        switch (rims) {
            case '19’’ Gemini Wheels':
                return 'gemini'
            case '20’’ Induction Wheels':
                return 'induction'
            case '21’’ Überturbine Wheels':
                return 'uberturbine'
            default:
                return 'gemini'
        }
    }

    getImageUrl(paint, rims): string {
        return `${this.translatePaint(paint)}-${this.translateRims(rims)}`
    }

    openInteriorView(): void {
        this.dialog.open(InteriorViewModelYComponent, {
            width: '100%',
            height: '100%',
            hasBackdrop: false,
        })
    }
}
